export enum myAccountTrackingEvents {
  MY_ACCOUNT_FREE_TRIAL_BANNER_SHOWN = 'My Account Free Trial Banner Shown',
  MY_ACCOUNT_FREE_TRIAL_BANNER_CLICKED = 'My Account Free Trial Banner Clicked',
  MY_ACCOUNT_USER_INFORMATION_EDITED = 'My Account User Information Edited',
}
